export default __webpack_public_path__ + "static/media/nibbleSlide2.4736b4d8.png";